import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import './Auth.css';

function TrocarSenhaObrigatoria() {
  const navigate = useNavigate();
  const { refreshUser, logout } = useAuth();

  const [senhaAtual, setSenhaAtual] = useState('');
  const [novaSenha, setNovaSenha] = useState('');
  const [confirmacao, setConfirmacao] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (novaSenha.length < 8) {
      setError('A nova senha deve ter no mínimo 8 caracteres.');
      return;
    }

    if (novaSenha !== confirmacao) {
      setError('As senhas não conferem.');
      return;
    }

    setLoading(true);
    try {
      await axios.post('/auth/change-password', {
        senha_atual: senhaAtual,
        nova_senha: novaSenha,
      });
      await refreshUser();
      navigate('/', { replace: true });
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(detail || 'Erro ao trocar senha. Tente novamente.');
      console.error('trocar-senha-obrigatoria:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h1>CoreWood</h1>
          <h2>Troca de senha obrigatória</h2>
          <p>Por segurança, defina uma nova senha antes de continuar.</p>
        </div>

        <form onSubmit={handleSubmit} className="auth-form">
          {error && <div className="auth-error">{error}</div>}

          <div className="form-group">
            <label>Senha atual</label>
            <input
              type="password"
              value={senhaAtual}
              onChange={(e) => setSenhaAtual(e.target.value)}
              required
              autoFocus
            />
          </div>

          <div className="form-group">
            <label>Nova senha</label>
            <input
              type="password"
              value={novaSenha}
              onChange={(e) => setNovaSenha(e.target.value)}
              placeholder="Mínimo 8 caracteres"
              required
            />
          </div>

          <div className="form-group">
            <label>Confirmar nova senha</label>
            <input
              type="password"
              value={confirmacao}
              onChange={(e) => setConfirmacao(e.target.value)}
              placeholder="Repita a nova senha"
              required
            />
          </div>

          <button type="submit" className="auth-button" disabled={loading}>
            {loading ? (<><span className="spinner"></span>Salvando...</>) : 'Trocar senha'}
          </button>
        </form>

        <div className="auth-footer">
          <button onClick={logout} className="link-button">
            Sair
          </button>
        </div>
      </div>
    </div>
  );
}

export default TrocarSenhaObrigatoria;
